import {images} from './images'
import {CategoryDetails, Category, MetaTagsProps} from "@/types";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
    Camera,
    Video,
    Palette,
} from 'lucide-react';
import {category as service1, createMetaTags as tags1} from "./1";
import {category as service2, createMetaTags as tags2} from "./2";
import {category as service3, createMetaTags as tags3} from "./3";
import {category as service4, createMetaTags as tags4} from "./4";
import {category as service5, createMetaTags as tags5} from "./5";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";


const slug = 'residential-and-domestic-excavation-sydney';
const categoryId = 1
export const headCategory: Category = {
    id: 1,
    key: 'residential',
    name: 'Residential & Domestic Excavation Services',
    long_name: 'Residential & Domestic Excavation Services Sydney',
    slug,
    categoryType: 'services',
}

export const metaTags: MetaTagsProps = {
    title: `Residential & Domestic Excavation Services Sydney | ${BUSINESS_NAME}`,
    description: "Reliable residential excavation solutions across Sydney. From small backyard projects to major site preparations, we specialise in tight-access excavation with precision and safety.",
    keywords: "residential excavation sydney, domestic excavation services, backyard excavation, site preparation, tight-access excavation, precision excavation, safe excavation practices, small-scale excavation, residential construction support, landscaping excavation, pool excavation, foundation excavation, trenching services, sydney builders",
    url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}`,
    ogImage: `${OG_PATH}c${categoryId}.jpg`,
    type: "website",
}
export const subCategoryObject = Object.fromEntries(
    Object.entries({
        category1Service1: {...service1, ...tags1(metaTags)},
        category1Service2: {...service2, ...tags2(metaTags)},
        category1Service3: {...service3, ...tags3(metaTags)},
        category1Service4: {...service4, ...tags4(metaTags)},
        category1Service5: {...service5, ...tags5(metaTags)}
    }).map(([key, value]) => [key, {...value, headCategory}])
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
    ...headCategory,
    metaTags,
    order: 1,
    icon: <EmojiEventsIcon/>,
    description: ['Reliable residential excavation solutions across Sydney. From small backyard projects to major site preparations, we specialise in tight-access excavation with precision and safety.'],
    points: [
        {
            title: '',
            icon: Camera,
        },
        {
            title: '',
            icon: Video,
        },
        {
            title: '',
            icon: Palette,
        },
    ],
    videos: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    subCategories,
}
